import { render, staticRenderFns } from "./UsersRelevancy.vue?vue&type=template&id=195d9016&scoped=true"
import script from "./UsersRelevancy.vue?vue&type=script&lang=js"
export * from "./UsersRelevancy.vue?vue&type=script&lang=js"
import style0 from "./UsersRelevancy.vue?vue&type=style&index=0&id=195d9016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d9016",
  null
  
)

export default component.exports